import { Component, OnInit, inject, ViewChild, ElementRef } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SystemApp } from '../../constans/SystemConfigurations';
import { ApiUrl } from '../../shared/models/apiurl.models';
import {ContactMenuComponent} from "../contact-menu/contact-menu.component";
import {Router} from "@angular/router";
import { DragScrollDirective } from '../../shared/directives/drag-scroll.directive';
import { CardBizBadgesComponent, CardDealerComponent } from '../card-seller/card-seller.component';

interface Sale2City { id: number; nameHe: string; }
interface Sale2Street { id: number; nameHe: string; }
interface Sale2Image { image: string; SortNum: number | null; }
interface SubCategory { id: number; subCategoryName: string; }
interface ProductStatus { id: number; statusName: string; }
interface AdsRoute { id: number; title: string; level: string; }
interface UserContact { id: number; contactPerson: string; phoneNumber: string; }
interface SconderyCategory { id: number; name: string; subCategory: string; }

interface Sale2 {
  id: number;
  name: string;
  price: number | null;
  images: Sale2Image[];
  City: Sale2City;
  Street: Sale2Street;
  subCategory: SubCategory;
  ProductStatus: ProductStatus;
  sconderyCategory: SconderyCategory;
  adsRoute: AdsRoute;
  userContactDetails: UserContact;
  FreeText: string | null;
  DeliveryOffer: boolean | null;
  average_rating: string | null;
  total_ratings: number;
  statusAds: string;
  /** Present on every product; used to detect internal (admin) ads merged into this listing. */
  resourcetype?: string;
  /** Generic Product fields — only populated on internal ads, not on real Sale2 rows. */
  description?: string;
  city?: { id: number; nameHe: string } | null;
}

interface Sale2Response { page_size: number; object_list: Sale2[]; }

@Component({
    selector: 'app-sale2-listings',
    imports: [ContactMenuComponent, DragScrollDirective, CardBizBadgesComponent, CardDealerComponent],
    templateUrl: 'sale2-bar.component.html',
    styleUrls: ['sale2-bar.component.scss']
})
export class Sale2ListingsComponent implements OnInit {
  private http = inject(HttpClient);
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  };

  items: Sale2[] = [];
  isLoading = false;
  error: string | null = null;

  @ViewChild('sale2Track') sale2Track!: ElementRef<HTMLElement>;

  private apiUrl = SystemApp.base_url_api + '/clientAjax/productVFilteriewSet';

  constructor(private apiKey: ApiUrl, private route: Router) {}

  ngOnInit(): void { this.loadItems(); }

  loadItems(): void {
    this.isLoading = true;
    this.error = null;
    this.http
        .post<Sale2Response>(
            `${this.apiUrl}?limit=36&offset=1&model_class=sale2`,
            {},
            { headers: this.options.headers }
        )
        .pipe(catchError((err) => { this.error = err.message; this.isLoading = false; return of(null); }))
        .subscribe((res) => { if (res) this.items = res.object_list; this.isLoading = false; });
  }

  scrollLeft(): void { this.sale2Track.nativeElement.scrollBy({ left: -360, behavior: 'smooth' }); }
  scrollRight(): void { this.sale2Track.nativeElement.scrollBy({ left: 360, behavior: 'smooth' }); }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'https://placehold.co/400x260/e8e4df/8a8580?text=🛒';
  }

  formatPrice(price: number | null): string {
    if (!price) return 'ליצירת קשר';
    return '₪' + price.toLocaleString();
  }

  getRatingStars(rating: string | null): number {
    return rating ? Math.round(parseFloat(rating)) : 0;
  }

  isPromoted(item: Sale2): boolean { return item.adsRoute.level !== 'LEVEL1'; }

  /**
   * Internal (admin) ads linked to this category are merged into the same
   * listing by the backend. They only carry the generic Product fields
   * (name/price/images/description/city), none of the sale2-specific ones —
   * so they need a simpler card.
   */
  isInternalAd(item: Sale2): boolean {
    return (item.resourcetype || '').toLowerCase() === 'internalads';
  }
  openPage(id:any){
    this.route.navigate([`single/${id}`])
  }
  getAdsBadge(level: string): string {
    switch (level) {
      case 'LEVEL3': return '⭐ VIP';
      case 'LEVEL2': return '🔥 מודגשת';
      default: return '';
    }
  }

  navigateToPage() {
    this.route.navigate([`shop/sale2`])
  }
}